(function () {
  var MAX_EMPTY_PAGES = 3;
  var REQUEST_TIMEOUT = 12000;
  var instance = null;
  var refreshTimer = null;
  var retry = 'Afficher plus';
  var loading = 'Chargement...';

  function InfiniteScroll(container) {
    this.container = resolveContainer(container);
    this.grid = this.container ? this.container.querySelector('[data-infinite-grid]') : null;
    this.mount = this.container ? this.container.querySelector('#infinite-scroll-sentinel') : null;
    this.loader = this.container ? this.container.querySelector('#infinite-loader') : null;
    this.pagination = this.container ? this.container.querySelector('[data-rp-pagination-fallback]') : null;
    this.mode = this.container && this.container.dataset.rpInfiniteMode ? this.container.dataset.rpInfiniteMode : 'load_more';
    this.sectionId = this.container && this.container.dataset.sectionId ? this.container.dataset.sectionId : '';
    this.retryLabel = this.mount && this.mount.dataset.retry ? this.mount.dataset.retry : retry;
    this.loadingLabel = this.mount && this.mount.dataset.loading ? this.mount.dataset.loading : loading;
    this.showMoreLabel = this.mount && this.mount.dataset.showMore ? this.mount.dataset.showMore : 'Afficher plus';
    this.addedOne = this.mount && this.mount.dataset.addedOne ? this.mount.dataset.addedOne : '1 produit ajouté';
    this.addedMany = this.mount && this.mount.dataset.addedMany ? this.mount.dataset.addedMany : '__COUNT__ produits ajoutés';
    this.endLabel = this.mount && this.mount.dataset.end ? this.mount.dataset.end : 'Tous les produits disponibles sont affichés.';
    this.noMoreLabel = this.mount && this.mount.dataset.noMore ? this.mount.dataset.noMore : 'Aucun autre produit à afficher.';
    this.timeoutLabel = this.mount && this.mount.dataset.timeout ? this.mount.dataset.timeout : 'Le chargement a pris trop de temps.';
    this.errorLabel = this.mount && this.mount.dataset.error ? this.mount.dataset.error : 'Impossible de charger les produits.';
    this.nextUrl = normalizeUrl(this.mount && (this.mount.dataset.nextUrl || getNextUrl(this.container)));
    this.loadedUrls = new Set();
    this.loadedItemKeys = this.grid ? collectItemKeys(this.grid) : new Set();
    this.loading = false;
    this.lastError = false;
    this.abortController = null;
    this.requestTimer = null;
    this.observer = null;
    this.destroyed = false;
    this.stopped = false;
    this.button = null;
    this.live = null;
    this.onClick = this.loadNext.bind(this);
  }

  InfiniteScroll.prototype.init = function () {
    if (!this.grid || !this.mount || !this.nextUrl) {
      this.setPaginationActive(false);
      this.removeIdleControls();
      return false;
    }

    this.button = buildButton(this.grid);
    this.live = buildLiveRegion();
    this.mount.replaceChildren(this.button);
    this.mount.insertAdjacentElement('afterend', this.live);
    this.button.addEventListener('click', this.onClick);
    this.setPaginationActive(true);
    if (this.mode === 'automatic') this.observe();
    this.updateControls();
    return true;
  };

  InfiniteScroll.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;
    this.clearRequest();
    if (this.button) this.button.removeEventListener('click', this.onClick);
    if (this.observer) this.observer.disconnect();
    this.hideLoader();
    this.setPaginationActive(false);
  };

  InfiniteScroll.prototype.setPaginationActive = function (active) {
    if (this.container) this.container.classList.toggle('rp-infinite-scroll-active', !!active);
    if (this.pagination) {
      this.pagination.hidden = !!active;
      this.pagination.toggleAttribute('hidden', !!active);
    }
  };

  InfiniteScroll.prototype.observe = function () {
    var self = this;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.mode !== 'automatic' || reducedMotion || this.destroyed || this.stopped || this.lastError || !this.nextUrl || !('IntersectionObserver' in window)) return false;
    if (this.observer) this.observer.disconnect();
    this.observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) self.loadNext();
    }, { rootMargin: '600px 0px', threshold: 0.01 });
    this.observer.observe(this.mount);
    return true;
  };

  InfiniteScroll.prototype.setStatus = function (message) {
    if (this.live) this.live.textContent = message || '';
  };

  InfiniteScroll.prototype.getAddedMessage = function (count) {
    var template = count === 1 ? this.addedOne : this.addedMany;
    return String(template).replace(/__COUNT__|\{\{?\s*quantity\s*\}?\}/g, String(count));
  };

  InfiniteScroll.prototype.hideLoader = function () {
    if (!this.loader) return;
    this.loader.hidden = true;
    this.loader.setAttribute('aria-hidden', 'true');
  };

  InfiniteScroll.prototype.updateControls = function () {
    if (this.loader) {
      this.loader.hidden = !this.loading;
      this.loader.setAttribute('aria-hidden', this.loading ? 'false' : 'true');
    }
    if (!this.button) return;
    var automaticObserverActive = this.mode === 'automatic' && this.observer && !this.lastError;
    this.button.hidden = !this.nextUrl || this.stopped || automaticObserverActive;
    this.button.disabled = this.loading || !this.nextUrl || this.stopped;
    this.button.setAttribute('aria-busy', this.loading ? 'true' : 'false');
    this.button.textContent = this.lastError ? this.retryLabel : this.loading ? this.loadingLabel : this.showMoreLabel;
  };

  InfiniteScroll.prototype.clearRequest = function () {
    if (this.requestTimer) window.clearTimeout(this.requestTimer);
    this.requestTimer = null;
    if (this.abortController) this.abortController.abort();
    this.abortController = null;
  };

  InfiniteScroll.prototype.removeIdleControls = function () {
    if (this.loader) this.loader.remove();
    if (this.mount) this.mount.remove();
    this.loader = null;
    this.mount = null;
  };

  InfiniteScroll.prototype.stopInfiniteScroll = function (reason) {
    if (this.stopped) return;
    this.stopped = true;
    this.nextUrl = null;
    this.loading = false;
    this.lastError = false;
    if (this.observer) this.observer.disconnect();
    this.observer = null;
    this.clearRequest();
    this.hideLoader();
    this.setPaginationActive(true);

    if (this.button) {
      this.button.removeEventListener('click', this.onClick);
      this.button.remove();
      this.button = null;
    }
    if (this.mount) {
      this.mount.remove();
      this.mount = null;
    }
    if (this.loader) {
      this.loader.remove();
      this.loader = null;
    }
    this.setStatus(reason === 'max-empty-pages'
      ? this.noMoreLabel
      : this.endLabel);
  };

  InfiniteScroll.prototype.loadNext = async function () {
    if (this.destroyed || this.stopped || this.loading || !this.nextUrl || !this.sectionId) return;

    var requestUrl = this.nextUrl;
    var retryUrl = requestUrl;
    var emptyPages = 0;
    var timedOut = false;
    this.loading = true;
    this.lastError = false;
    this.updateControls();
    this.setStatus(this.loadingLabel);

    try {
      while (requestUrl && emptyPages < MAX_EMPTY_PAGES) {
        if (this.loadedUrls.has(requestUrl)) {
          this.stopInfiniteScroll('duplicate-url');
          return;
        }

        retryUrl = requestUrl;
        var sectionUrl = buildSectionUrl(requestUrl, this.sectionId);
        if (!sectionUrl) throw new Error('Invalid pagination URL');
        timedOut = false;
        this.abortController = new AbortController();
        this.requestTimer = window.setTimeout(function (controller) {
          timedOut = true;
          controller.abort();
        }, REQUEST_TIMEOUT, this.abortController);

        var response = await fetch(sectionUrl, {
          credentials: 'same-origin',
          signal: this.abortController.signal,
          headers: { Accept: 'text/html' }
        });

        window.clearTimeout(this.requestTimer);
        this.requestTimer = null;
        this.abortController = null;
        if (!response.ok) throw new Error('Pagination request failed: ' + response.status);

        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var nextContainer = doc.getElementById('ProductGridContainer') || doc.querySelector('[data-section-id="' + CSS.escape(this.sectionId) + '"]');
        var nextGrid = nextContainer && nextContainer.querySelector('[data-infinite-grid]');
        if (!nextGrid) throw new Error('Product grid not found');

        var self = this;
        var uniqueItems = Array.from(nextGrid.querySelectorAll(':scope > li.grid__item')).filter(function (item) {
          var key = getItemKey(item);
          return !key || !self.loadedItemKeys.has(key);
        });
        var followingUrl = normalizeUrl(getNextUrl(nextContainer));

        this.loadedUrls.add(requestUrl);
        if (uniqueItems.length) {
          uniqueItems.forEach(function (item) {
            var key = getItemKey(item);
            if (key) self.loadedItemKeys.add(key);
            item.querySelectorAll('script, style').forEach(function (unsafeNode) { unsafeNode.remove(); });
            self.grid.appendChild(item);
          });
          if (window.customElements && typeof window.customElements.upgrade === 'function') {
            uniqueItems.forEach(function (item) { window.customElements.upgrade(item); });
          }
          resetNewItemAnimations(uniqueItems);
          this.nextUrl = followingUrl;
          this.setStatus(this.getAddedMessage(uniqueItems.length));
          document.dispatchEvent(new CustomEvent('retroparty:products-appended', {
            detail: { grid: this.grid, items: uniqueItems, url: requestUrl }
          }));
          if (!this.nextUrl) this.stopInfiniteScroll('end-of-results');
          return;
        }

        emptyPages += 1;
        if (!followingUrl || this.loadedUrls.has(followingUrl)) {
          this.stopInfiniteScroll('empty-final-page');
          return;
        }
        requestUrl = followingUrl;
        this.nextUrl = followingUrl;
      }
      this.stopInfiniteScroll('max-empty-pages');
    } catch (error) {
      if (this.destroyed || this.stopped) return;
      this.clearRequest();
      this.loading = false;
      this.lastError = true;
      this.nextUrl = retryUrl;
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      this.hideLoader();
      this.setPaginationActive(false);
      this.setStatus(timedOut ? this.timeoutLabel + ' ' + this.retryLabel : this.errorLabel + ' ' + this.retryLabel);
      this.updateControls();
    } finally {
      if (this.requestTimer) window.clearTimeout(this.requestTimer);
      this.requestTimer = null;
      this.abortController = null;
      this.loading = false;
      this.hideLoader();
      if (!this.stopped && !this.destroyed) {
        this.updateControls();
        if (this.mode === 'automatic' && !this.lastError) this.observe();
      }
    }
  };

  function resetNewItemAnimations(items) {
    items.forEach(function (item) {
      item.querySelectorAll('.scroll-trigger--cancel').forEach(function (element) { element.classList.remove('scroll-trigger--cancel'); });
    });
  }

  function buildSectionUrl(nextUrl, sectionId) {
    if (!nextUrl || !sectionId || String(nextUrl).trim().indexOf('//') === 0) return null;
    try {
      var url = new URL(nextUrl, window.location.origin);
      if ((url.protocol !== 'http:' && url.protocol !== 'https:') || url.origin !== window.location.origin || url.username || url.password) return null;
      url.hash = '';
      url.searchParams.set('section_id', sectionId);
      return url.toString();
    } catch (error) {
      return null;
    }
  }

  function resolveContainer(container) {
    var candidate = container && container.querySelector ? container : document;
    if (candidate.id === 'ProductGridContainer') return candidate;
    return candidate.querySelector('#ProductGridContainer') || candidate;
  }

  function buildButton(grid) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--secondary rp-load-more-button';
    button.setAttribute('aria-controls', grid.id || 'product-grid');
    return button;
  }

  function buildLiveRegion() {
    var region = document.createElement('p');
    region.className = 'rp-load-more-status visually-hidden';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    return region;
  }

  function collectItemKeys(grid) {
    return new Set(Array.from(grid.querySelectorAll('li.grid__item')).map(getItemKey).filter(Boolean));
  }

  function getItemKey(item) {
    if (!item) return '';
    if (item.dataset.productId) return 'id:' + item.dataset.productId;
    if (item.dataset.productUrl) return 'url:' + normalizeProductUrl(item.dataset.productUrl);
    var card = item.querySelector('[data-product-url]');
    if (card && card.dataset.productUrl) return 'url:' + normalizeProductUrl(card.dataset.productUrl);
    var link = item.querySelector('a[href*="/products/"]');
    return link && link.href ? 'url:' + normalizeProductUrl(link.href) : '';
  }

  function normalizeProductUrl(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return String(url).split('?')[0].split('#')[0].replace(/\/$/, '');
    }
  }

  function normalizeUrl(url) {
    if (!url || String(url).trim().indexOf('//') === 0) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      if ((parsed.protocol !== 'http:' && parsed.protocol !== 'https:') || parsed.origin !== window.location.origin || parsed.username || parsed.password) return null;
      parsed.hash = '';
      return parsed.href;
    } catch (error) {
      return null;
    }
  }

  function getNextUrl(scope) {
    if (!scope || !scope.querySelector) return null;
    var sentinel = scope.querySelector('#infinite-scroll-sentinel[data-next-url]');
    if (sentinel && sentinel.dataset.nextUrl) return sentinel.dataset.nextUrl;
    var next = scope.querySelector('a[rel="next"], a.pagination__item--next, .pagination .next a');
    return next && next.href ? next.href : null;
  }

  function init(container) {
    if (instance) instance.destroy();
    instance = new InfiniteScroll(container || document);
    if (!instance.init()) instance = null;
    return instance;
  }

  function destroy() {
    if (instance) instance.destroy();
    instance = null;
  }

  function scheduleRefresh(event) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      init(event && event.target && event.target.querySelector ? event.target : document);
    }, 80);
  }

  window.RPInfiniteScroll = { init: init, destroy: destroy };
  document.addEventListener('retroparty:product-grid-updating', destroy);
  document.addEventListener('retroparty:product-grid-updated', function (event) {
    init(event.detail && event.detail.container ? event.detail.container : document);
  });
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:unload', destroy);
  window.addEventListener('pageshow', function (event) { if (event.persisted) scheduleRefresh(event); });
  window.addEventListener('popstate', scheduleRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
